<div class="input-group mobile-tools-bar">
    <div [class.active]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'RECT'"
         class="input-group-btn">
        <button (click)="toggleAreaHighlighting($event)"
                class="reveal">
            <img [src]="'draw-mode/icon-tool-notes.png' | asset" alt="Notizenmodus" class="sidebar-icon">
        </button>
    </div>
    <div [class.active]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'SELECTION'"
         class="input-group-btn">
        <button (click)="toggleTextHighlighting($event)"
                class="reveal">
            <img [src]="'draw-mode/icon-tool-marker.png' | asset" alt="Textmarkierung" class="sidebar-icon">
        </button>
    </div>
    <div [class.active]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'COPY'"
         class="input-group-btn">
        <button (click)="toggleTextCopying($event)"
                class="reveal">
            <img [src]="'draw-mode/icon-tool-copy.png' | asset" alt="Text kopieren" class="sidebar-icon">
        </button>
    </div>
    <div class="input-group-btn">
        <div class="dropup">
            <button aria-expanded="true" aria-haspopup="true" data-bs-toggle="dropdown">
                <img [src]="'download-page.png' | asset" alt="Textmarkierung" class="sidebar-icon">
            </button>
            <ul aria-labelledby="mobile-tools" class="dropdown-menu dropdown-menu-end">
                <app-tools-bar-drop-up [isMobileVersion]="true"></app-tools-bar-drop-up>
            </ul>
        </div>
    </div>
</div>
